import { css } from '@emotion/react';
import { ToolCard } from '@/components/page-sections/ToolCard';
import { getScreen } from '@/styles/media-query';
import { withPrefix } from 'gatsby';

export type ToolSectionProps = {
  className?: string;
};

export const ToolSection: React.FC<ToolSectionProps> = ({ className }) => {
  return (
    <section id="tool" className={className}>
      <ul
        css={css`
          display: grid;
          gap: 56px;
          max-width: 290px;
          margin: 0 auto;

          @media ${getScreen('pc')} {
            padding: 0 20px;
            max-width: 1038px;
            grid-template-columns: repeat(3, 1fr);
            gap: 64px;
          }
        `}
      >
        {[
          {
            head: 'ダッシュボード機能',
            items: ['IPOロードマップ', 'タスクのサマリー情報', '課題・運用のサマリー情報'],
            imageSrc: withPrefix('/images/tool/tool-icon-10.png'),
          },
          {
            head: 'ナビゲーション機能',
            items: ['タスク一覧', '必要タスクの逆引き検索', 'Uniforce推奨ロードマップ'],
            imageSrc: withPrefix('/images/tool/tool-icon-1.png'),
          },
          {
            head: 'プロジェクト管理機能',
            items: ['タスク管理機能', '課題管理機能', '運用管理機能'],
            imageSrc: withPrefix('/images/tool/tool-icon-3.png'),
          },
          {
            head: 'セルフチェック機能',
            items: ['人事労務セルフチェック', 'ショートレビューセルフチェック', 'チェック結果から課題を作成'],
            imageSrc: withPrefix('/images/tool/tool-icon-2.png'),
          },
          {
            head: '資本政策表機能',
            items: ['資本政策表を作成・編集', '株主情報・株主分類の編集', '資本政策表のエクセル出力'],
            imageSrc: withPrefix('/images/tool/tool-icon-4.png'),
          },
          {
            head: '各種設定・個人設定機能',
            items: ['メンバー管理', 'IPアドレス制限設定', '二要素認証設定'],
            imageSrc: withPrefix('/images/tool/tool-icon-9.png'),
          },
          {
            head: <>ストックオプション機能 <sup>※</sup></>,
            items: ['個人単位での資料管理', 'Excel管理では実現できない整合性チェック', '有価証券報告書対応'],
            imageSrc: withPrefix('/images/tool/tool-icon-2.png'),
            caution: '※本機能はオプション機能のため、別途契約が必要です。',
            option: true,
          },
        ].map((item, i) => (
          <li key={i}>
            <ToolCard {...item} />
          </li>
        ))}
      </ul>
      
      <div
        css={css`
          max-width: 1000px;
          width: calc(100% - 40px);
          margin: auto;
          margin-top: 60px;
          padding: 30px;
          border: 30px solid #caefed;
          border-radius: 16px;
        `}
      >
        <h3
          css={css`
            margin-bottom: 20px;
            text-align: center;
            font: normal normal bold 20px/31px Noto Sans JP;
            letter-spacing: 0.96px;
            color: #00B3A7;
            
            @media ${getScreen('pc')} {
              font: normal normal bold 24px/35px Noto Sans JP;
            }
            
          `}
        >困ったときの相談窓口機能</h3>
        <p
          css={css`
            margin-bottom: 20px;
            text-align: center;
            font: normal normal bold 16px/25px Noto Sans JP;
            letter-spacing: 0.8px;
            
            @media ${getScreen('pc')} {
              font: normal normal bold 20px/29px Noto Sans JP;
            }
            
            strong {
              color: #00B3A7;
            }
            small {
              font: normal normal medium 14px/20px Noto Sans JP;
              letter-spacing: 0.56px;
              color: #252A40;
            }
          `}
        >
          <strong>小さなお悩み</strong>でもUniforceに<strong>ご相談</strong>ください！
          <br />
          <small>こんなお悩みでも大丈夫です！！</small>
        </p>
        <ul
          css={css`
            display: flex;
            justify-content: center;
            gap: 20px 0;
            flex-wrap: wrap;
            
            li {
              width: 100%;
              text-align: center;
              
              @media ${getScreen('pc')} {
                width: 198px;
              }
              
            }
          `}
        >
          <li><img src={withPrefix('/images/tool/tool-con_img_1.png')} alt="今ある規定を変更したいけどアドバイスが欲しい…" width={198} /></li>
          <li><img src={withPrefix('/images/tool/tool-con_img_2.png')} alt="誰に相談したらいいのかがわからない…" width={198} /></li>
          <li><img src={withPrefix('/images/tool/tool-con_img_3.png')} alt="IPO経験のある専門家が見つからない…" width={198} /></li>
        </ul>
      </div>
    </section>
  );
};
